export default __webpack_public_path__ + "static/media/bg-1.9b38d9e5.svg";